import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
    return (<>
        <div className="martin-footer">
            <ul>
                <li><a href="https://github.com/nzuqi" target="_blank" rel="noreferrer"><i className="icon-github"></i></a></li>
                {/* <li><a href="https://stackoverflow.com/users/5630225/martins" target="_blank" rel="noreferrer"><i className="icon-stackoverflow"></i></a></li> */}
                {/* <li><a href="https://www.behance.net/martinnzuki" target="_blank" rel="noreferrer"><i className="icon-behance"></i></a></li> */}
                {/* <li><a href="https://dribbble.com/nzuki" target="_blank" rel="noreferrer"><i className="icon-dribbble2"></i></a></li> */}
                {/* <li><a href="https://facebook.com/nzuqi" target="_blank" rel="noreferrer"><i className="icon-facebook2"></i></a></li> */}
                <li><a href="https://twitter.com/nzuqi" target="_blank" rel="noreferrer"><i className="icon-twitter2"></i></a></li>
            </ul>
            <p style={{ fontSize: '10px' }}>
                &copy; {new Date().getFullYear()} &middot; All rights reserved
                <span className="d-block"><Link to="/privacy">Privacy policy</Link></span>
            </p>
        </div>
    </>);
}